import { MessageService } from './../../../../services/messages.service';
import { EntityTransactionProfileService } from 'app/entities/transaction-profile/entity-transaction-profile.service';
import { EntityTransactionProfileModule } from 'app/entities/transaction-profile/entity-transaction-profile.module';
import { FormErrors } from 'app/shared/validators/generic-validators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';
import { Component, OnInit } from '@angular/core';
import { SnackBarService } from 'app/services/snackbar.service';
import { Agreement } from 'app/entities/transaction-profile/agreement.model';

@Component({
    selector: 'save-agreement',
    templateUrl: './save-agreement.component.html',
})

export class SaveAgreementComponent implements OnInit {
    action: string;
    entityId: number;
    agreementDetails: Agreement;
    saveAgreementForm: FormGroup;
    selectedAgreementId: number;
    loading = false;

    formErrors = {
        'description': '',
        'agreementDate': ''
    };

    validationMessages = {
        'description': {
            'required': 'Required field value.'
        },
        'agreementDate': {
            'required': 'Required field value.'
        },
    };

    constructor(
        public dialogRef: MdDialogRef<any>,
        private formBuilder: FormBuilder,
        private snackBarService: SnackBarService,
        private transactionProfileService: EntityTransactionProfileService) { }

    ngOnInit() {
        this.buildForm();
        if (this.action === 'Edit') {
            this.updateAgreementForm();
        }
    }

    buildForm() {
        this.saveAgreementForm = this.formBuilder.group({
            description: ['', Validators.required],
            agreementDate: ['', Validators.required],
        });
        this.saveAgreementForm.valueChanges.subscribe(data => this.onValueChanged(data));
    }

    onValueChanged(data?: any) {
        if (!this.saveAgreementForm) {
            return;
        }
        FormErrors('saveAgreementForm', this);
    }

    updateAgreementForm(): void {
        if (this.agreementDetails) {
            this.selectedAgreementId = this.agreementDetails.id;
            this.saveAgreementForm.patchValue({
                description: this.agreementDetails.description,
                agreementDate: this.parseEffectiveDate(this.agreementDetails.effectiveDate)
            });
        }
    }

    onSubmit({ value, valid }) {
        this.loading = true;
        const agreement = new Agreement();
        agreement.description = value.description;
        agreement.effectiveDate = this.formatDateForApi(value.agreementDate) as any;
        agreement.relationEntityId = this.entityId;
        if (this.agreementDetails) {
            agreement.id = this.selectedAgreementId;
            agreement.documents = this.agreementDetails.documents;
        }
        this.transactionProfileService.saveAgreement(agreement).subscribe(response => {
            this.loading = false;
            if (response.flagResult) {
                this.dialogRef.close(response.arrResult);
            }
            this.callSnackBarService(response);
        }, err => {
            this.loading = false;
            this.callSnackBarService(err);
        });
    }

    callSnackBarService(response: any) {
        this.snackBarService
            .showStatus(response,
            MessageService.AGREEMENT_SAVE_SUCCESS,
            MessageService.AGREEMENT_SAVE_FAILURE);
    }

    closeDialog() {
        this.dialogRef.close();
    }

    private parseEffectiveDate(date: Date | string | number): Date | null {
        if (date == null || date === '') {
            return null;
        }
        if (date instanceof Date) {
            return isNaN(date.getTime()) ? null : date;
        }
        if (typeof date === 'number') {
            const parsed = new Date(date);
            return isNaN(parsed.getTime()) ? null : parsed;
        }
        if (typeof date === 'string') {
            const unpaddedMatch = date.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
            if (unpaddedMatch) {
                const parsed = new Date(
                    Number(unpaddedMatch[1]),
                    Number(unpaddedMatch[2]) - 1,
                    Number(unpaddedMatch[3])
                );
                return isNaN(parsed.getTime()) ? null : parsed;
            }
            const parsed = new Date(date);
            return isNaN(parsed.getTime()) ? null : parsed;
        }
        return null;
    }

    private formatDateForApi(date: Date | string | number): string {
        const parsed = this.parseEffectiveDate(date);
        if (!parsed) {
            return null;
        }
        const year = parsed.getFullYear();
        const month = ('0' + (parsed.getMonth() + 1)).slice(-2);
        const day = ('0' + parsed.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/transaction-profile/agreements/saveagreement/save-agreement.component.ts